<template>
	<vxe-modal v-model="showFlag" title="NB采集器水表配置" :destroy-on-close="true"
					remember :esc-closable="false" width="600" show-footer>
		<div class="actDiv">
			<a-input-search style="width:15rem; font-size: 0.6875rem;"  @search="queryMeterInfo()"
						v-model="meterAddr" placeholder="请输入14位表地址">
				<a-button slot="enterButton">
					<a-icon type="plus" />
				</a-button>
			</a-input-search>
			<label style="font-size: 0.8rem;color: red;margin-left: 0.625rem;">注：提交后生效</label>
		</div>
		<vxe-table  align="center" :data="dataList"  border   show-overflow="tooltip" size="mini" max-height="500"
						  resizable highlight-hover-row  row-id="id" style="margin-bottom: 2rem;" :loading="loading">
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="NB采集器地址" field="collector_addr"></vxe-table-column>
				<vxe-table-column title="水表地址" field="meter_addr" ></vxe-table-column>
				<vxe-table-column title="操作" field="id" width="120">
					<template #default="{ row }">
						<a-button  size="small"  type="link"  @click="deleteItem(row)">删除</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<template #footer>
			<div class="drawerFooter">
			    <a-button size="small" icon="close" @click="onClose()" style="margin-right: 0.5rem;">取 消</a-button>
			    <a-button size="small"  icon="check" type="primary" @click="onSubmit" :loading="submiting">提 交</a-button>
			</div>
		</template>
	</vxe-modal>
</template>

<script>
	export default {
		data() {
			return {
				collectorAddr:null,
				showFlag: false,
				dataList:[],
				loading:false,
				meterAddr:null,
				submiting:false,
			}
		},
		methods: {
			showView(collectorAddr) {
				this.showFlag = true;
				this.collectorAddr = collectorAddr;
				this.queryData();
			},
			queryData(){
				this.loading = true;
				let param = {
					collectorAddr:this.collectorAddr,
				};
				let url = this.Api.getLastUrl(this.Api.COMMON_QUERY_NBCOLLECTOR_METER_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			onClose(){
				this.showFlag = false;
				this.dataList = [];
				this.meterAddr = null;
			},
			onSubmit(){
				this.submiting = true;
				let url = this.Api.getLastUrl(this.Api.COMMON_QUERY_NBCOLLECTOR_METER_CONFIG_URL);
				let obj = {
					collectorAddr:this.collectorAddr,
					meterList:this.dataList
				}
				this.Api.fetchPostWithJson(url,JSON.stringify(obj)).then((data)=>{
					this.submiting = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("配置成功");
						this.onClose();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
						this.submiting = false;
						console.log(error);
				});
			},
			queryMeterInfo(){
				this.loading = true;
				let param = {
					collectorAddr:this.collectorAddr,
					meterAddr:this.meterAddr,
				};
				let url = this.Api.getLastUrl(this.Api.COMMON_QUERY_NBCOLLECTOR_METER_CHECK_ADD_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList.push(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			deleteItem(row){
				var index = this.dataList.indexOf(row);
				this.dataList.splice(index,1);
			}
			
		},
	}
</script>

<style>
</style>
